import { SvgIcon, SvgIconProps } from "@mui/material";
export const Point = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10.1036" fill="#606A78" />
      </svg>
    </SvgIcon>
  );
};
